<template>
  <div class="index page-index" v-cloak ref="index">
    <!-- <img src="../../assets/images/indexbg.png" alt=""> -->
    <div class="follow acea-row row-between-wrapper" v-if="followHid && isWeixin">
      <div>点击“立即关注”即可关注公众号</div>
      <div class="acea-row row-middle">
        <div class="bnt" @click="followTap">立即关注</div>
        <span class="iconfont icon-guanbi" @click="closeFollow"></span>
      </div>
    </div>
    <div class="followCode" v-if="followCode">
      <div class="pictrue"><img :src="followUrl" /></div>
      <div class="mask" @click="closeFollowCode"></div>
    </div>
    <div class="title_index" :class="{ 'title_index_back': titleIndex }" :style="getBackgroundStyle">
      <div class="noticebar">
        <NoticeBar background="rgba(255,255,255,0.8)" sticky mode="link" style="white-space:nowrap" left-icon="volume-o"
          scrollable :text="roll" @click="$router.push({ path: '/userNotice', query: { type: 3, } })">
        </NoticeBar>
      </div>

      <div class="header acea-row row-center-wrapper">
        <router-link :to="'/search'" class="search acea-row row-middle">
          <div class="searchCity">{{ cityLine }}</div><span class="iconfont icon-xiazai5"></span>搜索你喜欢的商品
        </router-link>
      </div>
    </div>
    <!-- 导航条 -->
    <!-- <div class="nav-sort-wrapper">
            <div class="sort-icon-right" @click="gotoCategory()">
              <div class="sort-icon iconfont icon-yingyongchengxu-xianxing"></div><span class="sort-text">分类</span>
            </div>
            <div class="nav-sort-content"></div>
        </div> -->

    <!-- 消息轮播 -->

    <div class="fixed-element"></div>
    <!--  轮播图-->
    <div class="slider-banner banner" :class="{ 'top-margin': fixedSearch }">
      <swiper :options="swiperOptions" v-if="banner.length > 0" ref="swipers">
        <swiper-slide v-for="(item, index) in banner" :key="index">
          <img :src="item.pic" />
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>
    <!-- 跑马灯 -->
    <!-- <div class="news acea-row row-between-wrapper">
        <div class="pictrue"><img src="@assets/images/news.png" /></div>
        <div class="swiper-no-swiping new-banner">
          <swiper
            class="swiper-wrapper"
            :options="swiperRoll"
            v-if="roll.length > 0"
          >
            <swiper-slide
              class="swiper-slide"
              v-for="(item, index) in roll"
              :key="index"
            >
              <router-link
                :to="item.wap_url ? item.wap_url : ''"
                class="acea-row row-between-wrapper"
              >
                <div class="text acea-row row-between-wrapper">
                  <div class="label" v-if="item.show === '是'">最新</div>
                  <div class="newsTitle line1">{{ item.info }}</div>
                </div>
                <div class="iconfont icon-xiangyou"></div>
              </router-link>
            </swiper-slide>
          </swiper>
        </div>
      </div> -->

    <div class="specialArea acea-row row-between-wrapper" v-if="activityOne.wap_link !== undefined || activity.length">
      <router-link :to="activityOne.wap_link ? activityOne.wap_link : ''" v-if="activityOne.wap_link !== undefined"
        class="assemble">
        <img v-lazy="activityOne.pic" alt="img" />
        <div class="text">
          <div class="name">{{ activityOne.title }}</div>
          <div class="infor">{{ activityOne.info }}</div>
        </div>
      </router-link>

      <div class="list acea-row row-column-between">
        <router-link :to="item.wap_link ? item.wap_link : ''" class="item" v-for="(item, index) in activity"
          :key="index">
          <img v-lazy="item.pic" alt="img" />
          <div class="text">
            <div class="name">{{ item.title }}</div>
            <div class="infor">{{ item.info }}</div>
          </div>
        </router-link>
      </div>
    </div>
    <!--  -->
    <!-- <div class="wrapper wrapper-sort" v-if="info.fastList.length > 0">
        <div class="nav-sort-top">
           <div class="nav-sort-top-alone" v-for="(item, ind) in info.fastList" :key="ind">
             <img v-lazy="item.pic"/>
             <div>{{item.cate_name}}</div>
           </div>
        </div>
      </div> -->

    <!-- 分类卡片 -->
    <Swipe :loop="false" @change="onchange">
      <SwipeItem>
        <div class="nav acea-row" v-if="info.firstCateList.length > 0" v-show="currer == 0">
          <div class="item" @click="goXuankuamovie">
            <div class="pictrue"><img src="@assets/images/moive1.png" alt="img" /></div>
            <div>电影专区</div>
          </div>
          <router-link class="item" :to="bookPath">
            <div class="pictrue" @click="ProhibitClicking(2)">
              <img src="@assets/images/index-books.png" alt="img" />
            </div>
            <div>图书专区</div>
          </router-link>
          <router-link class="item" :to="ticketPath">
            <div class="pictrue" @click="ProhibitClicking(3)"><img src="@assets/images/index-outdoorsa.png" alt="img" />
            </div>
            <div>旅游专区</div>
          </router-link>
          <!-- <div class="item" @click="goUncleCake">
            <div class="pictrue"><img src="@assets/images/cake1.png" alt="img" /></div>
            <div>蛋糕专区</div>
          </div> -->
          <div class='item' @click="GoTonewGoodsList(5,8)">
            <div class="pictrue" @click="ProhibitClicking(5 , 8)"><img src="@assets/images/memberTv.png" alt="img" />
            </div>
            <div>会员直冲</div>
          </div>
          <router-link :to="{
            path: goodsPath,
            query: { id: 23951, title: '演出票务', hierarchy: true }
          }" class='item'>
            <div class="pictrue" @click="ProhibitClicking(4)"><img src="@assets/images/perform.png" alt="img" /></div>
            <div>演出票务</div>
          </router-link>
          <!-- <div class="item" @click="goxuankuayc">
            <div class="pictrue"><img src="@assets/images/perform.png" alt="img" /></div>
            <div>演出票务</div>
          </div> -->

          <div @click="routerLink(item)" class="item" v-for="(item, index) in info.firstCateList" :key="index">
            <div class="pictrue" @click="ProhibitClicking(6, null, item)">
              <img v-lazy="item.pic" alt="img" />
            </div>
            <div>{{ text(item.cate_name) }}
            </div>
          </div>
        </div>
      </SwipeItem>
      <SwipeItem>
        <div class="nav acea-row" v-if="info.firstCateList.length > 0" v-show="currer != 0">
          <div class="item" @click="goXuankuamovie">
            <div class="pictrue"><img src="@assets/images/moive1.png" alt="img" /></div>
            <div>电影专区</div>
          </div>
          <router-link class="item" :to="bookPath">
            <div class="pictrue" @click="ProhibitClicking(2)">
              <img src="@assets/images/index-books.png" alt="img" />
            </div>
            <div>图书专区</div>
          </router-link>
          <router-link class="item" :to="ticketPath">
            <div class="pictrue" @click="ProhibitClicking(3)"><img src="@assets/images/index-outdoorsa.png" alt="img" />
            </div>
            <div>旅游专区</div>
          </router-link>
          <!-- <div class="item" @click="goUncleCake">
            <div class="pictrue"><img src="@assets/images/moive1.png" alt="img" /></div>
            <div>蛋糕专区</div>
          </div> -->
          <div class='item' @click="GoTonewGoodsList(5,8)">
            <div class="pictrue" @click="ProhibitClicking(5, 8)"><img src="@assets/images/memberTv.png" alt="img" />
            </div>
            <div>会员直冲</div>
          </div>
          <router-link :to="{
            path: goodsPath,
            query: { id: 23951, title: '演出票务', hierarchy: true }
          }" class='item'>
            <div class="pictrue" @click="ProhibitClicking(4)"><img src="@assets/images/perform.png" alt="img" /></div>
            <div>演出票务</div>
          </router-link>
          <div @click="routerLink(item)" class="item" v-for="(item, index) in info.firstCateList" :key="index">
            <div class="pictrue" @click="ProhibitClicking(6, null, item)">
              <img v-lazy="item.pic" alt="img" />
            </div>
            <div>{{ text(item.cate_name) }}
            </div>
          </div>
          <router-link :to="{
            path: tongPath,
            query: { id: item.id, title: item.cate_name, hierarchy: true }
          }" class="item" v-for="(item, index) in info.lastCateList" :key="index">
            <div class="pictrue" @click="ProhibitClicking(6, null, item)">
              <img v-lazy="item.pic" alt="img" />
            </div>
            <div>{{ text(item.cate_name) }}
            </div>
          </router-link>
        </div>
      </SwipeItem>
      <template #indicator>
        <div class="custom-indicator">
          <div class="custom-indicatordi" :class="currer == 0 ? 'custom-indicatordiv' : ''"></div>
          <div class="custom-indicatordi" :class="currer == 1 ? 'custom-indicatordiv' : ''"></div>
        </div>
      </template>
    </Swipe>

    <!-- 分类下轮播 -->
    <div class="slider-banner banner">
      <swiper :options="swiperOption" v-if="scrolling.length > 0">
        <swiper-slide v-for="(item, index) in scrolling" :key="index">
          <img :src="item.pic" />
        </swiper-slide>
      </swiper>
    </div>

    <!-- 热门商品/品牌旗舰 -->
    <div class="wrapper hotshop">
      <div class="hot" @click="$router.replace({ path: '/index_hot', query: { type: 1 } })">
        <div class="hot_n">
          <div class="hoth">热门商品</div>
          <div class="hotp">人气热卖</div>
        </div>
        <div><img src="" alt=""><span class="hotSize">
            <Icon name="fire" />热销top跟着买
          </span></div>
        <div class="shop">
          <div class="shop_img" v-for="(item, index) of hotSalesIndex" :key="index">
            <!-- <div class="shop_icon">top</div> -->
            <div>
              <img :src="item.image" alt="">
              <div class="shop_price">
                <img src="@/assets/images/icon-money.png" alt="">
                <div class="size">{{ item.price }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flagship">
        <div class="hot" @click="$router.replace({ path: '/index_hot', query: { type: 2 } })">
          <div class="hot_n">
            <div class="hoth">品牌旗舰</div>
          </div>
          <div><img src="" alt=""><span class="hotSize">官方买手精选推荐</span></div>
          <div class="shop">
            <div class="shop_img" v-for="(item, index) of brandIndex" :key="index">
              <!-- <div class="shop_icon">top</div> -->
              <div>
                <img :src="item.image" alt="">
                <div class="shop_price">
                  <img src="@/assets/images/icon-money.png" alt="">
                  <div class="size">{{ item.price }}</div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- 热门推荐 -->
    <div class="wrapper module-shop-sort">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">精品推荐</div>
          <div class="line1">上百种商品任您选择</div>
        </div>
      </div>
      <!-- 热门推荐缘分类 -->
      <!-- <div class="wrapper wrapper-sort" v-if="info.fastList.length > 0">
        <div class="nav-sort-top">
          <router-link :to="{
            path: '/goods_list',
            query: { id: item.id, title: item.cate_name }
          }" class="nav-sort-top-alone" v-for="(item, ind) in info.fastList" :key="ind">
            <img v-lazy="item.pic" />
            <div>{{ item.cate_name }}</div>
          </router-link>
        </div>
      </div> -->
      <!-- 商品滚动 -->
      <vue-seamless-scroll :data="scollList" class="seamless-warp" :class-option="optionLeft" ref="seamlessScroll">
        <div class="scrollNew">
          <div class="scrollWaper" v-for="(item, index) of scollList" :key="index">
            <router-link :to="{ path: '/detail/' + item.id }">
              <div class="scrollimg">
                <img :src="item.image" alt="">
              </div>
              <div class="scrollName">{{ item.store_name }}</div>
              <div class="scrollMoney">
                <div style="display: flex;">
                  <img src="@/assets/images/icon-money.png" alt="">
                  <div>{{ item.price }}</div>
                </div>
                <div class="addCard">+</div>
              </div>
            </router-link>
          </div>
        </div>
      </vue-seamless-scroll>
    </div>
    <!--热门推荐结束  -->

    <!-- 原来的精品推荐+数据 -->
    <!-- <div
        class="wrapper"
        v-if="info.bastList.length > 0 || info.bastBanner.length > 0"
      >
        <div class="title acea-row row-between-wrapper">
          <div class="text">
            <div class="name line1">精品推荐</div>
            <div class="line1">{{ info.bastInfo }}</div>
          </div>
          <router-link :to="{ path: '/hot_new_goods/' + 1 }" class="more"
            >更多<span class="iconfont icon-jiantou"></span
          ></router-link>
        </div>
          <Good-list :good-list="info.bastList" :is-sort="false"></Good-list>
      </div> -->
    <!-- 原有精品推荐+数据 结束 -->

    <!-- 分类 -->
    <div class="nav-sort-top paginationshop" :class="{ 'fixed-paginationshop': fixedNav }">
      <div v-for="(item, ind) in shopNavList" :key="ind" class="paginationslot"
        :class="{ activeNav: currentShopNav === ind }" @click="changeCurrentShopNav(ind, item)">{{ item.cate_name }}
        <div class="towPagina" :class="{ towactiveNav: currentShopNav === ind }">{{ item.subtitle }}</div>
      </div>
    </div>

    <div class="wrapper sort-shop-swiper" :class="{ 'top-margin': fixedNav }">
      <div class="slider-banner shop-banner">
        <swiper :options="shopOption" ref="mySwiper">
          <swiper-slide v-for="(val, index) in shopNavList" :key="index">
            <div class="shop-page">
              <GoodList v-if="currentShopNav === index" :good-list="shopDataList" :is-sort="false"
                :isShowShopCart="false">
              </GoodList>
            </div>
          </swiper-slide>
        </swiper>
        <div v-if="loaded" class="page-text-center over-tip">已加载完成</div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
    <CouponWindow v-if="tipImage" :image="tipImage" @checked="couponClose" @close="couponClose"></CouponWindow>

    <div class="toastChuang" v-if="roastchuang">
      <div style="font-size: 0.3rem; padding-top: 0.3rem;">当前选择不支持购买</div>
      <div style="font-size: 0.23rem; padding-top: 0.1rem;"> 点击“我的兑换券”查看适用范围</div>
    </div>
    <div style="height:1.2rem;"></div>

    <div class="toastChuang" v-if="piaowumsg">
      <div style="font-size: 0.3rem; padding-top: 0.3rem;">因票务系统升级</div>
      <div style="font-size: 0.23rem; padding-top: 0.1rem;">暂时无法下单</div>
    </div>

    <div class="toastChuang" v-if="dangaomsg">
      <div style="font-size: 0.3rem; padding-top: 0.3rem;">蛋糕业务系统维护</div>
      <div style="font-size: 0.23rem; padding-top: 0.1rem;">预计下周三恢复</div>
    </div>

    <!-- <Overlay :show="nullUser"  duration="0">
      <div class="dialog-warp">
        <div class="size1">账号已被冻结</div>
        <div class="size2"> 因订单检测异常，存在倒卖/刷单等行为</div>
        <div class="size2"> 目前账号已被系统冻结</div>
        <div class="size3">如需解冻,可联系客服登记核实</div>
        <div class="button">
          <div class="buttonson" @click="nullUser = false">确 定</div>
        </div>
      </div>
    </Overlay>    -->
  </div>
</template>

<script>
import Loading from "@components/Loading";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
import PromotionGood from "@components/PromotionGood";
import CouponWindow from "@components/CouponWindow";
import { getHomeData, getShare, follow, uidToken } from "@api/public";
import { getProducts } from "@api/store";
import { xuankuaLoginSign, encryptedInformation } from "@api/movie";
import { dgLoginSign, dgLoginCodeSign } from "@api/cake"
import cookie from "@utils/store/cookie";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
import { getUserInfo, isBind } from "@api/user";
import { Icon, NoticeBar, Swipe, SwipeItem, Overlay } from 'vant'
import vueSeamlessScroll from "vue-seamless-scroll";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
let vm = null;
const BACK_URL = "login_back_url";

// alert(cookie.get(BACK_URL,"index1"))
// let count_change = 0;

export default {
  name: "Index",
  components: {
    swiper,
    swiperSlide,
    GoodList,
    PromotionGood,
    CouponWindow,
    Loading,
    NoticeBar,
    Swipe,
    SwipeItem,
    Icon,
    Overlay,
    vueSeamlessScroll
  },
  props: {},

  watch: {
    $route: function (n) {
      if (n.name == "Index") {
        // console.log(n.name);
        this.currer = 0
        this.isBindFn();

        //防止离开时滚动条缓存位置靠下而不显示导航
        // this.fixedSearch = false;
        // this.fixedNav = false;
      }
    },

  },
  data: function () {
    return {
      newGoodsBananr: "",
      isWeixin: isWeixin(),
      followUrl: "",
      subscribe: false,
      followHid: false,
      followCode: false,
      showCoupon: false,
      piaowumsg: false,
      dangaomsg: false,
      logoUrl: "",
      banner: [],
      menus: [],
      roll: [],
      activity: [],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: [],
        firstCateList: []
      },
      likeInfo: [],
      cityLine: '',//搜索框城市信息
      hotSalesIndex: [],//热销商品列表
      brandIndex: [],//品牌商品列表
      lovely: [],
      benefit: [],
      couponList: [],
      scrolling: [],//分类下轮播数据
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 5000
        },
        loop: true,
        // autoplay: false,
        // loop: false,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function () {
            const realIndex = this.realIndex;
            vm.goUrlTow(realIndex);
          },
        }
      },
      swiperOptions: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 5000
        },
        loop: true,
        // autoplay: false,
        // loop: false,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function () {
            const realIndex = this.realIndex;
            vm.goUrl(realIndex);
          },
          slideChange: function () {
            const activeIndex = this.realIndex // 当前轮播图的索引
            vm.goBackground(activeIndex)
          }
        }
      },
      shopOption: {
        autoplay: false,
        loop: false,
        observer: true,
        observeParents: true,
        speed: 800,
        on: {
          slideChange: () => {
            if (this.currentShopNav === this.swiper.activeIndex) return;
            this.changeType(this.swiper.activeIndex);

            //防抖 防止多次调用
            // count_change++;
            // console.log(count_change,"count_change");
            // if (count_change>1) {
            //   var timer = null;
            //   clearTimeout(timer);
            //   timer = setTimeout(()=> {
            //     this.changeType(this.swiper.activeIndex);
            //   }, 300)
            // } else {
            //   this.changeType(this.swiper.activeIndex);
            // }

          }
        }
      },
      hotOption: {
        loop: true,
        slidesPerView: 'auto',
        loopedSlides: 5,
        autoplay: {
          disableOnInteraction: false,
          delay: 5000
        },
      },
      swiperIndex: null,
      //
      shopNavList: [],
      currentShopNav: 0,
      shopDataList: [],
      page: 1,
      limit: 20,
      loaded: false,
      loading: false,
      shopType: null,
      delay: true,
      fixedNav: false,
      fixedSearch: false,
      titleIndex: false,
      //
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperClass: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        // loop: true,
        nested: true, // 添加nested属性
        autoplay: false,
      },

      mapKey: "",
      scrollPosition: null,
      scrollEnd: null,
      // 发货提醒图片
      tipImage: "",
      currer: 0,
      scrollingProduct: [],
      backgroundImageUrl: '',//首页轮播图上半部分
      scollList: [],// 首页自动播放商品数据列表
      type_details: [],
      bookPath: '',
      ticketPath: '',
      newGoodsPath: '',
      newGoodsPaths: '',
      goodsPath: '',
      tongPath: '',
      newGoodsNum: 0,
      roastchuang: false,
      member: null,//会员直充限制id
      tokenUid: '',
      nullUser: false,//首页判断能否操作
      cakePath: true,
      cakeCodePath: true,
      xuankuaYcPath: true,
      newGoodsokNo: false,
      indexK: []
    };
  },
  computed: {
    swiper: function () {
      return this.$refs.mySwiper.swiper
    },
    getBackgroundStyle() {
      return {
        'background-image': `url(${this.backgroundImageUrl})`,
        'background-size': '101%'
      };
    },
    optionLeft() {
      return {
        step: 0.5, // 数值越大速度滚动越快
        // limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
        // singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        // singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        // waitTime: 0, // 单步运动停止的时间(默认值1000ms)
      };
    }
  },
  created() {
    vm = this;
  },
  mounted: function () {
    this.getUserInfo()
    this.isBindFn();
    this.getFollow();
    this.$scroll(this.$refs.index, this.getData, this.handleScroll);
    this.nullUser = true
  },

  deactivated: function () {
    // 首页被缓存，删除滚动条监听会导致再次进入页面无法监听滚动条获取数据
    // this.$scroll.remove(this.$refs.index);
  },
  methods: {
    //请求用户信息
    getUserInfo() {
      getUserInfo().then(res => {
        if (res.data.status == 0) {
          this.$router.replace('/login')
        }
        if (res.data) {
          let id = res.data.uid
          uidToken(id).then(res => {
            if (res.data) {
              localStorage.setItem("LOGIN", res.data.token)
            }
          })
          this.is_book_tourism = res.data.is_book_tourism
          this.type_details = res.data.type_details
          if (res.data.type == 2) {
            this.$dialog.confirm({
              mes: '当前账户为体验账户，请勿下单或进行券操作',
              opts: () => {
                [
                  {
                    txt: '确认'
                  },
                  {
                    txt: '取消'
                  }
                ]
              }
            })
          }

          let data2 = this.type_details.indexOf('2')
          let data3 = this.type_details.indexOf('3')
          let data4 = this.type_details.indexOf('4')
          let data5 = this.type_details.indexOf('5')
          let data6 = this.type_details.indexOf('6')
          let data8 = this.type_details.indexOf('8')
          //蛋糕叔叔蛋糕页面暂时隐藏
          let data10 = this.type_details.indexOf('10')
          //蛋糕叔叔卡劵页面
          let data11 = this.type_details.indexOf('11')
          let data12 = this.type_details.indexOf('12')
          if (this.is_book_tourism == 1) {
            if (data12 == -1) {
              this.xuankuaYcPath = false
            } else {
              this.xuankuaYcPath = true
            }
          }
          if (this.is_book_tourism == 1) {
            if (data11 == -1) {
              this.cakeCodePath = false
            } else {
              this.cakeCodePath = true
            }
          }
          if (this.is_book_tourism == 1) {
            if (data10 == -1) {
              this.cakePath = false
            } else {
              this.cakePath = true
            }
          }

          if (this.is_book_tourism == 1) {
            if (data2 == -1) {
              this.bookPath = ''
            } else {
              this.bookPath = '/book'
            }
          } else {
            this.bookPath = '/book'
          }
          if (this.is_book_tourism == 1) {

            if (data3 == -1) {
              this.ticketPath = ''
            } else {
              this.ticketPath = '/ticket'
            }
          } else {
            this.ticketPath = '/ticket'
          }
          if (this.is_book_tourism == 1) {
            if (data4 == -1) {
              this.goodsPath = ''
            } else {
              this.goodsPath = ''
            }
          } else {
            if (data4 == -1) {
              this.goodsPath = ''
            } else {
              this.goodsPath = ''
            }
          }
          if (this.is_book_tourism == 1) {
            if (data5 == -1) {
              this.newGoodsPath = ''
              this.newGoodsNum = null
            } else {
              console.log("444")
              this.newGoodsNum = 5
              this.newGoodsPath = '/newGoods_list'
            }
          } else {
            this.newGoodsokNo = true
            this.newGoodsNum = 5
            this.newGoodsPath = '/newGoods_list'
          }
          if (this.is_book_tourism == 1) {
            if (data6 == -1) {
              this.tongPath = ''
            } else {
              this.tongPath = '/goods_list'
            }
          } else {
            this.tongPath = '/goods_list'
          }
          if (this.is_book_tourism == 1) {
            if (data8 == -1) {
              this.newGoodsPaths = ''
              this.newGoodsNum = null
            } else {
              this.newGoodsNum = 8
              this.newGoodsPaths = '/newGoods_list'
            }
          } else {
            this.newGoodsokNo = true
            this.newGoodsNum = 8
            this.newGoodsPaths = '/newGoods_list'
          }
        } else {
          this.$router.replace('/login')
        }
        this.getIndex()
      }).catch(err => {
        this.$router.replace('/login')
      })

    },
    //首页图标是否为虚拟券弹框
    ProhibitClicking(item, num, data) {
      console.log(item);

      if (item == 2 && this.bookPath == '') {
        this.roastchuang = true
        setTimeout(() => {
          this.roastchuang = false
        }, 2000)
      }
      if (item == 3 && this.ticketPath == '') {
        this.roastchuang = true
        setTimeout(() => {
          this.roastchuang = false
        }, 2000)
      }

      if( item == 4 ) {
        this.piaowumsg = true
        setTimeout(() => {
          this.piaowumsg = false
        }, 2000)
      }

      // if (item == 4 && this.goodsPath == '') {
      //   this.roastchuang = true
      //   setTimeout(() => {
      //     this.roastchuang = false
      //   }, 2000)
      // }
      if (item == 5 && this.newGoodsPath == ''&& this.newGoodsNum==5) {


        this.roastchuang = true
        setTimeout(() => {
          this.roastchuang = false
        }, 2000)
      }

      if (item == 6 && this.tongPath == '' && data.id != 999 && data.id != 9998 && data.id != 9997) {
        this.roastchuang = true
        setTimeout(() => {
          this.roastchuang = false
        }, 2000)
      }
      if (num == 8 && this.newGoodsPaths == ''&& this.newGoodsNum==8 ) {
        console.log(999);
        this.roastchuang = true
        setTimeout(() => {
          this.roastchuang = false
        }, 2000)
      }
    },
   // 会员跳转
    GoTonewGoodsList() {
      //会员直充、不包括美式

      if ( this.newGoodsPaths != '') {
        this.$router.push({
          path: this.newGoodsPaths,
        })
      }else if ( this.newGoodsPath != '' ) {
        this.$router.push({
          path: this.newGoodsPath,
        })
      }else{
        this.roastchuang = true
        setTimeout(() => {
          this.roastchuang = false
        }, 2000)
      }
    },
    //蛋糕跳转包括跳转控制
    routerLink(item) {
      console.log('item.id',item.id)
      if (item.id == 999) {
        if (this.cakePath) {
          // this.goUncleCake()
            this.dangaomsg = true
            setTimeout(() => {
              this.dangaomsg = false
            }, 2000)
          return ;
        } else {
          this.roastchuang = true
        }
      } else {
        this.$router.push({
          path: this.tongPath,
          query: { id: item.id, title: item.cate_name, hierarchy: true }
        })
      }
      if (item.id == 9998) {//品牌甜品
        if (this.cakeCodePath) {
          this.goUncleCodeCake()
        } else {
          this.roastchuang = true
        }
      } else {
        this.$router.push({
          path: this.tongPath,
          query: { id: item.id, title: item.cate_name, hierarchy: true }
        })
      }
      if (item.id == 9997) {
        if (this.xuankuaYcPath) {
          this.goxuankuayc()
        } else {
          this.roastchuang = true
        }
      } else {
        this.$router.push({
          path: this.tongPath,
          query: { id: item.id, title: item.cate_name, hierarchy: true }
        })
      }

    },
    getIndex() {
      let that = this;
      let data = this.type_details
      getHomeData(data).then(res => {
        if (res.data) {
          that.mapKey = res.data.tengxun_map_key;
          cookie.set(MAPKEY, that.mapKey);
          that.logoUrl = res.data.logoUrl;
          that.newGoodsBananr = res.data.newGoodsBananr;
          //获取分类导航数据
          that.shopNavList = res.data.info.cateList;
          that.shopType = res.data.info.cateList[that.currentShopNav].id;
          // 弹窗图片
          that.tipImage = res.data.sendImg || "";
          //
          that.$set(that, "banner", res.data.banner);
          this.backgroundImageUrl = res.data.banner[0].pic2
          that.$set(that, "menus", res.data.menus);
          that.$set(that, "scrolling", res.data.scrolling);
          that.$set(that, "hotSalesIndex", res.data.hotSalesIndex);
          that.$set(that, "brandIndex", res.data.brandIndex)
          //滚动数据
          // that.$set(that, "roll", res.data.roll);
          let roll = res.data.roll
          roll.forEach(el => {
            that.roll.push(el.info)
          })

          this.scollList = res.data.brandProduct
          this.$refs.seamlessScroll.reset()
          that.cityLine = res.data.cityLine
          that.$set(that, "activity", res.data.activity);
          if (res.data.activity.length) {
            var activityOne = res.data.activity.shift();
            that.$set(that, "activityOne", activityOne);
          }
          that.$set(that, "info", res.data.info);
          that.$set(that, "likeInfo", res.data.likeInfo);
          that.$set(
            that,
            "lovely",
            res.data.lovely.length ? res.data.lovely[0] : {}
          );
          that.$set(that, "benefit", res.data.benefit);
          that.$set(that, "couponList", res.data.couponList);
          that.subscribe = res.data.subscribe;
          if (!that.subscribe && that.followUrl) {
            setTimeout(function () {
              that.followHid = true;
            }, 200);
          } else {
            that.followHid = false;
          }
          if (res.data.site_name) document.title = res.data.site_name;
          that.setOpenShare();
          // this.showCoupon =
          //   !cookie.has(HAS_COUPON_WINDOW) &&
          //   res.data.couponList.some(coupon => coupon.is_use);
          if (!cookie.get(LATITUDE) && !cookie.get(LONGITUDE)) this.getWXLocation();
        }
      }).then(() => {
        this.delayGetData();
      });
    },
    goBackground(id) {
      let data = this.banner
      data.forEach((el, index) => {
        if (index == id) {
          this.backgroundImageUrl = el.pic2
        }
      })
    },
    isBindFn: function () {
      if (cookie.get('isbind')) return;
      isBind().then((res) => {
        const data = res.data.is_bind;
        if (!data) {
          if (cookie.get('temporary_token')) {
            this.$dialog.error("请前往绑卡进入商城");
            cookie.set(BACK_URL, "/");
            this.$router.replace({ path: "/user/bindcoupon", query: { id: "1" } });
            return;
          } else {
            this.$dialog.error("请登录");
            cookie.set(BACK_URL, "/");
            this.$router.replace({ path: "/login" });
            return;
          }
        }
      })
    },
    onchange(index) {
      this.currer = index
    },

    //去往活动详情
    // goActivity(item) {
    //   let data = this.scrolling
    //   data.forEach(el => {
    //     if (el.id == item.id) {
    //       location.href = item.url
    //     }
    //   })
    // },
    handleScroll: function (e) {
      let st = e.scrollY;
      this.scrollPosition = st;
      console.log(st, "st");
      // 搜索栏
      if (st > 200) {
        this.titleIndex = true;
      } else if (st < 180) {
        this.titleIndex = false;
      }
      if (this.fixedSearch && st < 180) {
        this.fixedSearch = !this.fixedSearch;
      }

      //控制商品分类导航条
      if (st >= 350) {
        this.fixedNav = true;
      }
      if (this.fixedNav && st < 640) {
        this.fixedNav = false;
      }
    },
    getIndexShopList: async function () {
      //console.log("请求数据", this.page)
      if (this.loading || this.loaded) return;
      let { page, limit, shopType, member } = this;
      this.loading = true;
      await getProducts({ page, limit, cid: shopType, type_detail: member }).then((res) => {
        if (res.data.length !== 0) {
          this.shopDataList = this.shopDataList.concat(res.data);
          this.page++;
        }
        this.loaded = res.data.length < this.limit;
        this.loading = false;
      }).catch((err) => {
        console.log(err);
      })
    },
    delayGetData: function () {
      if (this.delay) {
        this.getIndexShopList();
        this.delay = false;
      }
    },
    getData: function () {
      //console.log("开始监听", this.page, this.delay);
      if (!this.delay && this.page !== 1) {
        //console.log("调用方法");
        !this.loading && this.getIndexShopList();
      }
    },
    changeType: function (index, id) {
      this.currentShopNav = index;
      this.shopDataList = [];
      this.page = 1;
      this.loaded = false;
      this.loading = false;
      if (id) {
        this.shopType = id;
        if (id == 23049) {
          this.member = 8
        } else {
          this.member = null
        }
      } else {
        this.shopNavList.forEach((item, ind) => {
          if (index === ind) {
            this.shopType = item.id;
          }
        });
      }
      this.getIndexShopList();
      // 跳来跳去(点击分类时跳转到不同的页面)
      // window.scrollTo(0, 760);
    },
    //切换分类导航
    changeCurrentShopNav: function (index, item) {
      if (index === this.currentShopNav) return;
      this.changeType(index, item.id);
      this.swiper.slideTo(index, 100);
    },
    // 轮播图跳转
    goUrl(index) {
      let url = this.banner[index].wap_url;
      let newStr = url.indexOf("http") === 0;
      let id_6 = this.type_details.indexOf("6")
      let id_5 = this.type_details.indexOf("5")
      let id_2 = this.type_details.indexOf("2")
      let id_8 = this.type_details.indexOf("8")
      if (newStr) {
        if (this.is_book_tourism == 1) {
          if (index == 0) {
            if (id_6 == -1) {
              this.roastchuang = true
              setTimeout(() => {
                this.roastchuang = false
              }, 2000)
            } else {
              window.location.href = url;
            }
          }
          // if (index == 1) {
          //   if (id_5 == -1) {
          //     this.roastchuang = true
          //     setTimeout(() => {
          //       this.roastchuang = false
          //     }, 2000)
          //   } else {
          //     window.location.href = url;
          //   }
          // }
          if (index == 1) {
            if (id_8 == -1 && id_5 == -1) {
              this.roastchuang = true
              setTimeout(() => {
                this.roastchuang = false
              }, 2000)
            } else {
              window.location.href = url;
            }
          }
          if (index == 2) {
            if (id_2 == -1) {
              this.roastchuang = true
              setTimeout(() => {
                this.roastchuang = false
              }, 2000)
            } else {
              window.location.href = url;
            }
          }
        } else {
          window.location.href = url;
        }
      } else {
        if (this.is_book_tourism == 1) {
          if (index == 0) {
            if (id_6 == -1) {
              this.roastchuang = true
              setTimeout(() => {
                this.roastchuang = false
              }, 2000)
            } else {
              this.$router.push({
                path: url
              });
            }
          }
          if (index == 1) {
            if (id_5 == -1) {

              this.roastchuang = true
              setTimeout(() => {
                this.roastchuang = false
              }, 2000)
            } else {
              this.$router.push({
                path: url
              });
            }
          }
          if (index == 2) {
            if (id_2 == -1) {
              this.roastchuang = true
              setTimeout(() => {
                this.roastchuang = false
              }, 2000)
            } else {
              this.$router.push({
                path: url
              });
            }
          }
        } else {
          this.$router.push({
            path: url
          });
        }
      }
    },

    goUrlTow(index) {
      let url = this.scrolling[index].wap_url;
      let newStr = url.indexOf("http") === 0;
      let id_6 = this.type_details.indexOf("6")
      if (newStr) {
        if (this.is_book_tourism == 1) {
          if (id_6 == -1) {
            this.roastchuang = true
            setTimeout(() => {
              this.roastchuang = false
            }, 2000)
          } else {
            window.location.href = url;
          }
        } else {
          window.location.href = url;
        }
      } else {
        if (this.is_book_tourism == 1) {
          if (id_6 == -1) {
            this.roastchuang = true
            setTimeout(() => {
              this.roastchuang = false
            }, 2000)
          } else {
            this.$router.push({
              path: url
            });
          }
        } else {
          this.$router.push({
            path: url
          });
        }
      }
    },
    //-------------------------------
    // 电影跳转
    goXuankuamovie() {
      let id_ = this.type_details.indexOf('1')
      if (this.is_book_tourism == 1) {
        if (id_ == -1) {
          this.roastchuang = true
          setTimeout(() => {
            this.roastchuang = false
          }, 2000)
        } else {
          this.fangfan()
        }
      } else {
        this.fangfan()
      }
    },
    fangfan() {
      getUserInfo().then((res) => {
        if (!res.data.phone) {
          this.$dialog.error('请先绑定手机号');
          this.$router.push({ path: "/login" });
          return;
        }
        let data = {
          uid: res.data.uid,
          phone: res.data.phone
        };
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        const adminValue = params.get('admin');


        /*
        24年号段：80038912-80039679
        23年号段：80030660-80031404
         */
        console.log("adminValue:"+adminValue)
        if( adminValue !== 'yes' ){
            var guiZe = res.data.coupon_rule
            console.log("guiZe:"+guiZe)
          console.log("res.data.user_coupon_list",res.data.user_coupon_list)
            for (const value of res.data.user_coupon_list) {

              console.log("guiZe === 'guize1':",guiZe === 'guize1')
              console.log("guiZe === 'guize2':",guiZe === 'guize2')
                if(  guiZe === 'guize1' ){
                  if (
                      (value >= 80038912 && value <= 80039679) || // 24年号段
                      (value >= 80030660 && value <= 80031404) || // 23年号段
                      (value >= 80036832 && value <= 80037601)
                  ) {
                    this.$dialog.error('因系统升级，电影专区暂无法下单，请稍后尝试');
                    return;
                  }
                }else if( guiZe === 'guize2' ){
                  if(
                      (value < 80025986 || value > 80026005) &&
                      (value < 80033792 || value > 80033810) &&
                      (value < 80039840 || value > 80040475)
                  ){
                    this.$dialog.error('因系统升级，电影专区暂无法下单，请稍后尝试');
                    return;
                  }
                }
            }
        }

        xuankuaLoginSign(data).then((data) => {
          let sign = data.data && data.data.auth_code;
          let a = 'xiaojiang';
          let uid = res.data.uid
          if (sign) {
            //正式地址
            location.href = `https://wap.dumovie.com/xiaojiang/index?appkey=${a}&auth_code=${sign}&txid=${uid}`;
            // 测试地址
            // location.href = `https://testwap.mayiufu.com/xiaojiang/index?appkey=${a}&auth_code=${sign}&txid=${uid}`
          }
        }).catch((r) => {
          console.log(r);
        })
      })
    },

    //轩夸演出入口
    goxuankuayc() {
      getUserInfo().then((res) => {
        if (!res.data.phone) {
          this.$dialog.error('请先绑定手机号');
          this.$router.push({ path: "/login" });
          return;
        }
        let data = {
          uid: res.data.uid,
          phone: res.data.phone
        };
        xuankuaLoginSign(data).then((data) => {
          let sign = data.data && data.data.auth_code;
          let a = 'xiaojiang';
          let uid = res.data.uid
          if (sign) {
            //正式地址
            location.href = `https://wap.dumovie.com/drama/index?appkey=${a}&auth_code=${sign}&txid=${uid}`;
            // 测试地址
            // location.href = `https://testwap.mayiufu.com/drama/index?appkey=${a}&auth_code=${sign}&txid=${uid}`
          }
        }).catch((r) => {
          console.log(r);
        })
      })
    },

    //蛋糕叔叔跳转
    goUncleCake() {
      getUserInfo().then((res) => {
        if (!res.data.phone) {
          this.$dialog.error('请先绑定手机号');
          this.$router.push({ path: "/login" });
          return;
        }
        let data = {
          uid: res.data.uid,
        };
        dgLoginSign(data).then((data) => {
          console.log(data);

          let sign = data.data
          if (sign) {
            location.href = sign.dgUrl
          }

        })
      })
    },

    //蛋糕叔叔卡劵跳转
    goUncleCodeCake() {
      getUserInfo().then((res) => {
        if (!res.data.phone) {
          this.$dialog.error('请先绑定手机号');
          this.$router.push({ path: "/login" });
          return;
        }
        let data = {
          uid: res.data.uid,
        };
        dgLoginCodeSign(data).then((data) => {
          console.log(data);

          let sign = data.data
          if (sign) {
            location.href = sign.dgUrl
          }

        })
      })
    },
    //     gotoMovie() {

    // getUserInfo().then((res) => {
    //   if (!res.data.phone) {
    //     this.$dialog.error('请先绑定手机号');
    //     this.$router.push({ path: "/login" });
    //     return;
    //   }
    //   let data = {
    //     uid: res.data.uid,
    //     phone: res.data.phone
    //   };
    //   encryptedInformation(data).then((data) => {
    //     // console.log(data, "data")

    //     let sign = data.data && data.data.sign;
    //     if (sign) {
    //       location.href = `http://xj.daeyes.com.cn/index.html?source=xiaojiang&sign=${sign}`;
    //     }
    //   }).catch((r) => {
    //     console.log(r);
    //   })

    // })
    // },

    //跳转到分类页面
    gotoCategory() {
      this.$router.push('/category')
    },
    text: function (val) {
      if (val === "礼品办公") {
        return "户外办公";
      }
      return val;
    },
    //-------------------------------


    getWXLocation() {
      if (isWeixin()) {
        wxShowLocation();
      } else {
        if (!this.mapKey)
          console.log("暂无法使用查看地图，请配置您的腾讯地图key");
        let loc;
        // if (_this.$route.params.mapKey) _this.locationShow = true;
        //监听定位组件的message事件
        window.addEventListener(
          "message",
          function (event) {
            loc = event.data; // 接收位置信息 LONGITUDE
            if (loc && loc.module == "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              //定位组件在定位失败后，也会触发message, event.data为null
              console.log("定位失败");
            }
          },
          false
        );
      }
    },
    closeFollow() {
      this.followHid = false;
    },
    followTap() {
      this.followCode = true;
      this.followHid = false;
    },
    closeFollowCode() {
      this.followCode = false;
      this.followHid = true;
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    getFollow() {
      follow()
        .then(res => {
          this.followUrl = res.data.path;
        })
        .catch(() => { });
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: location.href,
            imgUrl: data.img
          };
          openShareAll(configAppMessage);
        });
      }
    }
  },
  activated: function () {
    // console.log(this.scrollEnd, this.scrollPosition);
    this.$nextTick(() => {
      window.scrollBy({ top: this.scrollEnd, left: 0, behavior: "auto" });
    });
  },
  beforeRouteLeave: function (to, from, next) {
    this.scrollEnd = this.scrollPosition;
    next();
  }
};
</script>
<style scoped>
[v-cloak] {
  display: none;
}

.page-background {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  /* width: 100%; */
  height: 4rem;
  /* background: url(../../assets/images/homebackground.png) no-repeat; */
  background-size: 100%;
}

.page-background .top {
  height: 2rem;
  background: linear-gradient(90deg, #FF5A5F 0%, #FF3854 100%);
}

.page-background .bottom {
  height: 1rem;
  background: linear-gradient(90deg, #FF5A5F 0%, #FF3854 100%);
  border-radius: 0 0 50% 50%;
}

.index {
  /* background-image:url(../../assets/images/indexbg.png); */
  /* background-color: #fff; */
  /* padding-top: 1.2rem; */
  position: relative;
}

.index .header {
  position: fixed;
  top: 0.8rem;
  left: 0;
  z-index: 9999;
}

.index .follow {
  z-index: 100000;
}

.keep {
  text-align: center;
}

.index .banner {
  width: 100%;
  height: auto;
  /* padding: 0 .24rem !important; */
}

.index .banner img {
  width: 100%;
  /* border-radius: .25rem !important; */
}

.nav-sort-wrapper {
  height: .9rem;
  background: red;
  width: 100%;
  box-sizing: border-box;
  padding: .1rem 1.1rem .1rem .1rem;
  position: relative;
}

.sort-shop-swiper {
  /* min-height: 27.1rem;一页排列3排18条的高度 */
  min-height: 13rem;
  /*一屏高*/
}

.nav-sort-content {
  overflow-x: scroll;
  white-space: nowrap;
  width: 100%;
  height: 100%;
}

.nav-sort-content::-webkit-scrollbar {
  display: none;
}

.sort-icon {
  display: inline-block;
  margin-right: .02rem;
}

.sort-icon-right {
  font-size: .26rem;
  position: absolute;
  right: .1rem;
  top: .25rem;
  color: white;
}

.module-shop-sort {
  margin-bottom: .2rem;
}

.wrapper-sort {
  margin: 0 .2rem;
  border-radius: .2rem;
  box-shadow: 0rem .1rem .1rem #f5f5f5;
}

.nav-sort-top {
  width: 100%;
  box-sizing: border-box;
  overflow-x: scroll;
  white-space: nowrap;
  padding: .2rem;
  margin-top: .1rem;
}

.nav-sort-top::-webkit-scrollbar {
  display: none;
}

.nav-sort-top-alone {
  width: 1.6rem;
  margin-right: .2rem;
  display: inline-block;
  text-align: center;
  overflow: hidden;
  border-bottom: .02rem solid lightblue;
}

.nav-sort-top-alone img {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: .1rem;
}

.nav-sort-top-alone div {
  text-align: center;
  line-height: .5rem;
}

.paginationshop {
  height: 1rem;
  padding: 0 .3rem;
  font-size: .28rem;
}

.fixed-paginationshop {
  position: fixed;
  top: 1.6rem;
  margin-top: 0;
  z-index: 999;
  background: #fff;
}

.fixed-search {
  position: fixed !important;
  top: 1;
  z-index: 99;
  background: #fff;
}

.paginationslot {
  display: inline-block;
  margin-right: .4rem;
  /* line-height: .8rem; */
  font-weight: 600;
  font-size: .25rem;
  min-width: 1.5rem;
  text-align: center;
}

.towPagina {
  font-size: .25rem;
  padding-top: 0.1rem;
  font-weight: 300;
  min-width: 1.5rem;
  height: .4rem;
  line-height: 0.2rem;
  text-align: center;
  font-family: PingFangMedium, sans-serif;

}

.towactiveNav {
  border-radius: 0.2rem;
  background: #E18C1B;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
  color: white;
  font-family: PingFangMedium, sans-serif;
  /* font-size: 0.28rem; */
}

.paginationslot:last-child {
  margin-right: 0;
}

.paginationshop .activeNav {
  color: #fc4141;
  /* font-size: .3rem; */
}

.top-margin {
  margin-top: .8rem;
}

.over-tip {
  line-height: 1rem;
  color: #868686;
}

.special_bgimage {
  width: 6.9rem;
  height: 2.2rem;
  margin-left: 0.3rem;
}

.special_bgimage img {
  width: 100%;
  height: 100%;
}

.special_wrapper {
  background: #FF908D url(../../assets/images/characteristic.png) no-repeat;
}

.special_content {
  width: 6.77rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  padding: 0.2rem;
  margin-top: -0.1rem;
}

.content_size1 {
  width: 100%;
  text-align: center;
  padding-top: 0.2rem;
  font-size: 0.3rem;
  font-family: 148-SSBiao Bang Ti-Regular, 148-SSBiao Bang Ti;
  color: #FFFFFF;
}

.content_size {
  width: 100%;
  text-align: center;
  padding-top: 0.2rem;
  font-size: 0.5rem;
  font-weight: 400;
  font-family: 148-SSBiao Bang Ti-Regular, 148-SSBiao Bang Ti;
  color: #FFFFFF;
}

.spe_con {
  width: 1.65rem;
  height: 2.5rem;
  background: #f5f5f5;
  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
  margin-left: 0.1rem;
  padding: 0.1rem;
}

.spe_con img {
  width: 1.2rem;
  margin: 0.2rem 0.1rem;
}

.classifyModular {
  width: 94%;
  height: 4rem;
  margin: 0.25rem;
  display: flex;
}

.modular_left {
  width: 33%;
  height: 100%;
  background: url('../../assets/images/modularNo1.png') no-repeat;
  background-position: right bottom;
  background-color: #FFEDED;
  border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
}

.left_title {
  padding-left: 0.3rem;
  padding-top: 0.3rem;
  font-size: 0.35rem;
  font-weight: 600;
  color: #F6433D;
}

.left_text {
  padding: 0.2rem 0.3rem;
  font-size: 0.23rem;
  color: #9F9F9F;
}

.top_title {
  padding-left: 0.3rem;
  padding-top: 0.3rem;
  font-size: 0.35rem;
  font-weight: 600;
  color: #E18C1B;
}

.top_text {
  padding: 0rem 0.3rem;
  font-size: 0.23rem;
  color: #9F9F9F;
}

.No1_title {
  padding-left: 0.3rem;
  padding-top: 0.1rem;
  font-size: 0.35rem;
  font-weight: 600;
  color: #35B293;
}

.No1_text {
  padding: 0rem 0.3rem;
  font-size: 0.23rem;
  color: #9F9F9F;
}

.No2_title {
  padding-left: 0.3rem;
  padding-top: 0.1rem;
  font-size: 0.35rem;
  font-weight: 600;
  color: #4F88F8;
}

.No2_text {
  padding: 0rem 0.3rem;
  font-size: 0.23rem;
  color: #9F9F9F;
}

.modular_rignt {
  width: 65%;
  margin-left: 0.15rem;
  height: 2rem;
}

.right_top {
  width: 100%;
  height: 2rem;
  background: url('../../assets/images/modularRightTop.png') no-repeat;
  background-position: right bottom;
  background-color: #FFF2E5;
  border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
}

.rigin_bottom {
  width: 100%;
  display: flex;
}

.bottom_No1 {
  width: 49%;
  height: 1.9rem;
  background-color: aqua;
  margin-top: 0.1rem;
  margin-right: 0.1rem;
  background: url('../../assets/images/bottomLeft.png') no-repeat;
  background-position: right bottom;
  background-color: #EDFFFD;
  border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
}

.bottom_No2 {
  width: 49%;
  height: 1.9rem;
  background-color: aqua;
  margin-top: 0.1rem;
  background: url('../../assets/images/bottomRight.png') no-repeat;
  background-position: right bottom;
  background-color: #EAF1FF;
  border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
}

.van-notice-bar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  width: 95%;
  margin-left: 0.2rem;
  height: 0.5rem;
  margin-top: 0.2rem;
  border-radius: 0.15rem;
}

.fixed-element {
  width: 100%;
  height: 1.6rem;
}

.hotshop {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding-top: 0.2rem;
  padding: 0.2rem 0.2rem;
}

.hotshop .hot {
  padding-left: 0.2rem;
  background: linear-gradient(180deg, #ffe9de 0%, #FFFFFF 100%);
  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
  height: auto;
  margin-right: 0.1rem;
}

.hotshop .flagship {
  padding-left: 0.2rem;
  background: linear-gradient(180deg, #ffe9de 0%, #FFFFFF 100%);
  border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
}

.hot .hot_n {
  display: flex;
  padding-top: 0.15rem;
}

.hot .hot_n .hoth {
  font-size: 0.4rem;
  font-family: "AlimamaShuHeiTi-Bold";
  font-weight: 400;
}

.hot .hot_n .hotp {
  width: 1.4rem;
  height: 0.4rem;
  text-align: center;
  line-height: 0.43rem;
  background: linear-gradient(160deg, #ffa003 30%, #fa630e 70%);
  border-radius: 0.2rem 0.2rem 0.2rem 0rem;
  margin-left: 0.1rem;
  color: white;
  font-size: 0.25rem;
}

.hotSize {
  color: #d39a59;
  font-size: 0.25rem;
}

.hot .shop {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.shop .shop_img {
  position: relative;
}

.shop .shop_img img {
  width: 1.4rem;
  height: 1.4rem;
  margin-top: 0.3rem;
  border-radius: 0.15rem;
}

.shop .shop_img .shop_icon {
  position: absolute;
  top: 0.1rem;
  width: 0.8rem;
  height: .35rem;
  background: linear-gradient(160deg, #ffa003 30%, #fa630e 70%);
  text-align: center;
  line-height: 0.35rem;
  font-family: "AlimamaShuHeiTi-Bold";
  color: white;
  font-size: 0.2rem;
  border-radius: 0.25rem 0.2rem 0.2rem 0rem;
}

.shop .shop_price {
  width: 100%;
  color: red;
  display: flex;
}

.shop .shop_price .size {
  padding-top: 0.05rem;
  color: #c25c65;
}

.shop .shop_price img {
  width: 0.4rem;
  height: 0.4rem;
  margin-top: 0rem !important;
}

.searchCity {
  min-width: 1rem;
  border-right: 0.01rem solid #ccc;
  color: #030303 !important;
  margin-right: 0.1rem;
}

.title_index {
  width: 100%;
  height: 1.6rem;
  background: white;
  position: fixed;
  z-index: 99;
}

.title_index_back {
  background: #ffa003;
}

.seamless-warp {
  width: 100%;
  height: 3.2rem;
  overflow: hidden;
  margin-top: 0.2rem;
  /* margin:0 auto; */
  background: #f3f0eb;
}

.scrollNew {
  width: 100%;
  height: 3.1rem;
  display: flex;
  overflow: hidden;
  padding-top: 0.1rem;
}

.scrollWaper {
  width: 2rem;
  height: 3rem;
  border-radius: 0.1rem;
  margin-left: 0.2rem;
  background: white;
}

.scrollimg {
  width: 2rem;
  text-align: center;
}

.scrollimg img {
  width: 1.5rem;
  height: 1.5rem;
  padding-top: 0.1rem;
}

.scrollName {
  width: 100%;
  height: 0.9rem;
  text-align: left;
  padding-left: 0.1rem;
  font-size: 0.2rem;
  font-family: PingFangMedium, sans-serif;
  padding-top: 0.2rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-box-pack: center;
  -webkit-box-align: center;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.scrollMoney {
  padding-top: 0.1rem;
  padding-left: 0.1rem;
  font-size: 0.25rem;
  color: #c25c65;
  display: flex;
}

.scrollMoney img {
  width: 0.4rem;
  height: 0.4rem;
  margin-top: -0.05rem !important;
}

.custom-indicator {
  display: flex;
  justify-content: space-around;
  width: 1rem;
  height: 0.16rem;
  background: #EDFFFD;
  margin-left: 3rem;
}

.addCard {
  margin-left: 0.4rem;
  /* margin-top: 0.05rem; */
  width: 0.25rem;
  height: 0.25rem;
  font-size: 0.3rem;
  text-align: center;
  line-height: 0.23rem;
  border-radius: 50%;
  background-color: red;
  color: #ffffff;
}

.custom-indicatordi {
  width: 0.5rem;
  height: 0.15rem;
  background: #f3f1f1;
  border-radius: 0.6rem 0.1rem 0.6rem 0.1rem;
}

.custom-indicatordiv {
  width: 0.5rem;
  height: 0.15rem;
  background: #f08f38;
  border-radius: 0.6rem 0.1rem 0.6rem 0.1rem;
}

.toastChuang {
  width: 4rem;
  height: 1.5rem;
  position: fixed;
  top: 30%;
  left: 26%;
  color: white;
  background: #484848;
  opacity: 0.9;
  text-align: center;
  border-radius: 0.25rem;
  z-index: 100;
}

.dialog-warp {
  /* width: 5.5rem; */
  /* height: 3rem; */
  position: fixed;
  top: 5rem;
  left: 55%;
  margin-left: -3rem;
  padding: 0.2rem;
  background-color: white;
  border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
  /* border: 0.02rem solid black; */
}

.dialog-warp .size1 {
  width: 100%;
  font-size: 0.3rem;
  color: rgb(83, 83, 83);
  text-align: center;
  margin-top: 0.4rem;
  font-weight: 600;
}

.dialog-warp .size1 span {
  color: red;
}

.dialog-warp .size2 {
  width: 100%;
  font-size: 0.3rem;
  color: rgb(83, 83, 83);
  text-align: center;
  margin-top: 0.1rem;
  font-weight: 600;
}

.dialog-warp .size3 {
  width: 100%;
  font-size: 0.25rem;
  color: black;
  text-align: center;
  margin-top: 0.3rem;
}

.dialog-warp .button {
  width: 100%;
  padding-left: 1.5rem;
  margin-top: 0.3rem;
}

.dialog-warp .button .buttonson {
  width: 2.5rem;
  height: 0.5rem;
  border-radius: 0.3rem;
  background: #f35446;
  color: white;
  text-align: center;
  line-height: 0.5rem;
  font-size: 0.3rem;
}

.van-overlay {
  z-index: 1000;
}
</style>
